import React from 'react';
import useFeatureFlags from './use-feature-flags.hook';

const FeatureFlags = ({ children }: { children: React.ReactNode }): JSX.Element => {
    useFeatureFlags();
    return <>{children}</>;
};

export default FeatureFlags;
